import React, { useEffect } from 'react';
import { IntlProvider } from 'react-intl';
// antd & dayjs
import { ConfigProvider } from 'antd';
import antdENUS from 'antd/lib/locale/en_US';
import antdZHCN from 'antd/lib/locale/zh_CN';
import 'dayjs/locale/zh-cn';

// app
import enUS from './locales/en-US';
import zhCN from './locales/zh-CN';
import './App.less';
import AppRouter from './app/router';
import 'antd/dist/reset.css';

import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import { getLocale } from './locales';

dayjs.extend(customParseFormat)
dayjs.extend(advancedFormat)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.extend(weekOfYear)
dayjs.extend(weekYear)

const locale=getLocale();
//const locale = 'en-US'; //getLocale();
//const locale='zh-CN';
const isZHCN = locale === 'zh-CN';
const messages = isZHCN ? zhCN : enUS;
const antdLocale = isZHCN ? antdZHCN : antdENUS;

function App() {
  useEffect(() => {
    
  }, []);

  return (
    <IntlProvider locale={locale} messages={messages}>
      <ConfigProvider 
        componentSize="middle" 
        locale={antdLocale} 
        theme={{
          components: {
            Button: {
              colorPrimary: '#3366FF',
              algorithm: true, // 启用算法
            },
            Switch: {
              colorPrimary: '#3366FF',
              algorithm: true, // 启用算法
            }
          },
        }}
      >
        <AppRouter />
      </ConfigProvider>
    </IntlProvider>
  );
}

export default App;
